/* eslint-disable quotes */
/* eslint-disable camelcase */
import inputNameError from '../../admin/services/inputNameError';
import TotalpassStorage from '../../config/totalpassStorage';

$(() => {
  if (!window.accountRegister) {
    return;
  }

  const storage = new TotalpassStorage('account-register');
  const already_exist = $("#container-email").data("already-exist");

  const copyEmailValueToRegister = () => {
    const emailToCopy = $('.account-new-validate-email form').find('[name*="email"]').val();
    $('.account-new-register form').find('[name*="account[gym_owner_attributes][email]"]').val(emailToCopy);
  };

  const showContainerRegister = () => {
    $('.account-new-validate-email').css('display', 'none');
    $('.account-new-register').css('display', 'flex');
  };

  const isErrorTaken = (currentValue) => currentValue.error === 'taken';

  const handleEmailError = (errors) => {
    if (errors.some(isErrorTaken)) {
      $('#modal-account-email-taken').modal();
    }
  };

  const handleMessageErrors = (messages) => {
    Object.keys(messages).forEach((message) => {
      if (messages[message][0]) {
        const inputName = `[name*='${inputNameError('account', message)}']:visible`;
        const errorMessage = messages[message][0];

        if ($(inputName).length && $(inputName).parents('.field-container-error').length) {
          $(inputName).parents('.field-container-error').after(`<p class="account-new-register-container-error-message">${errorMessage}</p>`);
        } else if ($(inputName).length) {
          $(inputName).addClass('account-new-register-input-error');
          $(inputName).after(`<p class="account-new-register-input-error-message">${errorMessage}</p>`);
        }
      }
    });
  };

  const checkErrorDetails = ((details) => {
    const inputsName = {
      'gym_owner.email': handleEmailError,
      default: () => { },
    };

    Object.keys(details).forEach((key) => (inputsName[key]
      ? inputsName[key](details[key]) : inputsName.default));
  });

  if (window.accountRegister.errors) {
    showContainerRegister();
    const { details, messages } = window.accountRegister.errors;

    checkErrorDetails(details);
    handleMessageErrors(messages);
  }

  $('.account-new-validate-email').on('submit', 'form', function (event) {
    event.preventDefault();
    let result = false;

    copyEmailValueToRegister();
    $(this).find('.error').remove();

    const data = $(this).serialize();

    $.ajax({
      type: 'POST',
      url: '/service_providers/accounts/validate_gym_owner_email',
      data,
      async: false,
      success: () => {
        result = true;
      },
      error: (response) => {
        const { errors } = response.responseJSON;
        const errorFirst = Object.values(errors)[0];
        $(this).append(`<p class='error'>${errorFirst}</p>`);

        if (errors.taken) {
          $('.account-new-validate-email-actions').css('display', 'flex');
          $(this).find('input[type=submit]').hide();
          $(this).find('input').val('');
          $(this).find('input').css('border', '2px solid red');
          $('p.error').html(already_exist);
          $('p.error').css('float', 'left');
          $('p.error').css('margin-top', '-10px');

          const hrefToLogin = $('.account-new-validate-email-actions-login').prop('href');
          $('.account-new-validate-email-actions-login').prop('href', `${hrefToLogin}?${data}`);
        }
      },
    });

    if (result) {
      showContainerRegister();
    }
  }).on('click', '.account-new-validate-email-actions-continue', () => {
    showContainerRegister();
  });

  $('.account-new-register form :input:not(.password-field)').change(function () {
    const key = $(this).attr('name');
    const value = $(this).val();
    storage.addRecord(key, value);
  }).each(function () {
    const key = $(this).attr('name');
    const value = storage.getRecord(key);
    if (value) {
      $(this).val(value);
    }
  });
});
